import { inject, Injectable, ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';

export class ProviderNotFoundError extends Error {
  constructor() {
    super('Provider Not Found');
    this.name = 'ProviderNotFoundError';
  }
}

export class ProviderPreviewExpiredError extends Error {
  constructor() {
    super('Provider Preview Expired');
    this.name = 'ProviderPreviewExpiredError';
  }
}

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly router = inject(Router);

  handleError(error: unknown) {
    if (error instanceof ProviderNotFoundError) {
      this.router.navigateByUrl('404');
      return; // prevent default
    }
    if (error instanceof ProviderPreviewExpiredError) {
      this.router.navigateByUrl('expired-preview');
      return; // prevent default
    }
    throw error;
  }
}
